module.exports = __webpack_public_path__ + "img/Diar_AnimacionPastilla.02ce8ee9.gif";